import Reveal from "@/components/motion/Reveal";

const PageHeader = ({ chapter, title, subtitle, testid }) => (
  <section data-testid={testid} className="relative overflow-hidden border-b border-line bg-surface">
    <div className="absolute inset-0 bg-blueprint opacity-60" aria-hidden="true" />
    <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 pt-36 lg:pt-44 pb-16 lg:pb-24">
      <Reveal>
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-brand">{chapter}</p>
      </Reveal>
      <Reveal delay={0.08}>
        <h1 className="mt-4 max-w-4xl font-display font-black uppercase tracking-tight leading-[0.92] text-4xl sm:text-5xl lg:text-6xl text-cream">
          {title}
        </h1>
      </Reveal>
      {subtitle && (
        <Reveal delay={0.16}>
          <p className="mt-6 max-w-2xl text-base sm:text-lg leading-relaxed text-fog">{subtitle}</p>
        </Reveal>
      )}
    </div>
  </section>
);

export default PageHeader;
